export default __webpack_public_path__ + "static/media/greek_pancakes.bad0714d.jpg";